import { Text, TopMenu } from '_/components';
import ContainerWidthLimit from '_/components/ContainerWidthLimit';
import { Image, ScrollView, StyleSheet, TouchableOpacity, View } from 'react-native';
import themes from '_/constants/themes';
import { fontFamily, fontSizes } from '_/config/theme';
import {
  Feather,
  FontAwesome,
  FontAwesome5,
  FontAwesome6,
  MaterialIcons,
} from '@expo/vector-icons';

import { useTranslation } from 'react-i18next';
import { useNavigation } from '@react-navigation/native';
import { AppRoute } from '_/routes/types';
import { useSelector } from 'react-redux';
import useSpaceManagement from '_/hooks/useSpaceManagement';
import isInvenzi from '_/helpers/isInvenzi';
import { useFlowRestrictions } from '_/hooks/useIsFlowBlocked';

export default function AccessControl() {
  const { t } = useTranslation();

  const { navigate } = useNavigation<any>();

  const { waccessIntegration, customization } = useSelector((state: any) => state.company);
  const hostAllowCredentialing = useSelector((state: any) => state?.host?.allowCredentialing);
  const hostSpaceManagementEnabled = useSelector(
    (state: any) => state?.host?.spaceManagementEnabled
  );
  const spaceManagement = useSpaceManagement((state) => state.spaceManagement);

  const { isVisitsBlocked, isCredentialingBlocked, isSpaceManagementBlocked, isQRcodeBlocked } =
    useFlowRestrictions();
  const disableQrcodeApp = useSelector((state: any) => state.company.disableQrcodeApp);

  const ItemRender = ({
    title,
    route,
    iconImage,
    iconName,
    icon,
  }: {
    title: string;
    route: AppRoute;
    iconImage?: any;
    iconName?: any;
    icon?: any;
  }) => {
    return (
      <View style={styles.cardContainer}>
        <TouchableOpacity style={styles.card} activeOpacity={0.85} onPress={() => navigate(route)}>
          <View style={styles.iconWrapper}>
            {iconName && (
              <Feather name={iconName} size={fontSizes.xl} color={themes.colors.primary} />
            )}

            {icon && icon}

            {iconImage && (
              <Image resizeMode="contain" source={iconImage} style={{ width: 30, height: 30 }} />
            )}
          </View>

          <Text size={12} fontType="semibold" color={themes.colors.grayPrimary} numberOfLines={2}>
            {title}
          </Text>
        </TouchableOpacity>
      </View>
    );
  };

  return (
    <ContainerWidthLimit>
      <View style={styles.container}>
        <TopMenu />

        <View style={styles.content}>
          <ScrollView style={{ padding: 16 }} showsVerticalScrollIndicator={false}>
            <View>
              <Text style={styles.sectionTitle}>{t('accesses')}</Text>
              <View style={styles.rowContainer}>
                {waccessIntegration?.HIDMobileAccess &&
                  ItemRender({
                    title: t('Credencial Mobile'),
                    route: AppRoute.HID_CARD,
                    iconImage: themes.images.hidLogo,
                  })}
                {!isQRcodeBlocked &&
                  !disableQrcodeApp &&
                  ItemRender({
                    title: t('QRCode'),
                    icon: (
                      <MaterialIcons
                        name="qr-code-scanner"
                        size={fontSizes.xl}
                        color={themes.colors.primary}
                      />
                    ),
                    route: AppRoute.QRCODE,
                  })}
                {spaceManagement?.spaceManagementEnabled &&
                  !isSpaceManagementBlocked &&
                  hostSpaceManagementEnabled &&
                  isInvenzi() &&
                  ItemRender({
                    title: t('general.spaceManagement'),
                    iconImage: themes.images.spaceManagementIcon,
                    route: AppRoute.SPACEMANAGEMENTTAB,
                  })}
              </View>
            </View>
            {customization?.credentialingEnabled &&
              hostAllowCredentialing &&
              !isCredentialingBlocked && (
                <View>
                  <Text style={styles.sectionTitle}>{t('credentials')}</Text>
                  <View style={styles.rowContainer}>
                    {ItemRender({
                      title: t('approvals'),
                      icon: (
                        <FontAwesome6
                          name="list-check"
                          size={fontSizes.xl}
                          color={themes.colors.primary}
                        />
                      ),
                      route: AppRoute.CREDENTIALING_APPROVALS,
                    })}
                    {ItemRender({
                      title: t('newCredential'),
                      icon: (
                        <FontAwesome
                          name="calendar-plus-o"
                          size={fontSizes.xl}
                          color={themes.colors.primary}
                        />
                      ),
                      route: AppRoute.CREDENTIALING,
                    })}
                  </View>
                </View>
              )}
            {!isVisitsBlocked && (
              <View>
                <Text style={styles.sectionTitle}>{t('visitors')}</Text>
                <View style={styles.rowContainer}>
                  {ItemRender({
                    title: t('general.invites'),
                    icon: (
                      <FontAwesome6
                        name="calendar-check"
                        size={fontSizes.xl}
                        color={themes.colors.primary}
                      />
                    ),
                    route: AppRoute.MEETINGS,
                  })}

                  {/* {ItemRender({
                    title: t('home.history'),
                    icon: (
                      <FontAwesome5
                        name="history"
                        size={fontSizes.xl}
                        color={themes.colors.primary}
                      />
                    ),
                    route: AppRoute.VISITS_HISTORY,
                  })} */}
                  {/* {ItemRender({
                  title: t('Agendados'),
                  icon: <MaterialIcons name="schedule" size={28} color={themes.colors.primary} />,
                  route: AppRoute.VISITS_HISTORY,
                })} */}
                </View>
              </View>
            )}
            <View>
              <Text style={styles.sectionTitle}>{t('Notifications')}</Text>
              <View style={styles.rowContainer}>
                {ItemRender({
                  title: t('Notifications'),
                  iconName: 'bell',
                  route: AppRoute.NOTIFICATION,
                })}
              </View>
            </View>
          </ScrollView>
        </View>
      </View>
    </ContainerWidthLimit>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: themes.colors.lightQuaternary,
    flex: 1,
  },
  content: {
    flex: 1,
  },
  rowContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  cardContainer: {
    width: '33.33%',
    padding: 6,
    marginBottom: 12,
  },
  iconWrapper: {
    width: 36,
    height: 36,
  },
  card: {
    backgroundColor: themes.colors.white,
    borderRadius: 16,
    paddingVertical: 14,
    paddingHorizontal: 12,
    height: 100,
    justifyContent: 'space-between',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.08,
    shadowRadius: 16,
    elevation: 3,
  },

  sectionTitle: {
    fontSize: 14.5,
    fontFamily: fontFamily.semibold,
    color: themes.colors.grayPrimary,
    marginBottom: 8,
    marginLeft: 4,
  },
});
